import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-sales-book-maye-preview',
  templateUrl: './sales-book-maye-preview.component.html',
  styleUrls: ['./sales-book-maye-preview.component.scss']
})
export class SalesBookMayePreviewComponent {
  @Input() data: any = null;
  tab: number = 0;
  title: string = null;

  headerGroups = [
    {
      label: 'Datos del Documento',
      colspan: 5,
      columns: [
        { key: 'fecha', label: 'Fecha', type: 'date' },
        { key: 'serie', label: 'Serie' },
        { key: 'numero', label: 'Número' },
        { key: 'documento', label: 'Tipo de Doc' },
        { key: 'operacion', label: 'Operación' }
      ]
    },
    {
      label: 'Datos del Vendedor o Prestador del Servicio',
      colspan: 2,
      columns: [
        { key: 'nit', label: 'NIT' },
        { key: 'nombre', label: 'Nombre Completo' }
      ]
    },
    {
      label: 'Base Gravada',
      colspan: 3,
      columns: [
        { key: 'neto', label: 'Bienes', format: 'money' },
        { label: 'Servicios', empty: true },
        { label: 'Impuesto Extra', empty: true }
      ]
    },
    {
      label: 'Exportaciones',
      colspan: 2,
      columns: [
        { label: 'Bienes', empty: true },
        { label: 'Servicios', empty: true }
      ]
    },
    {
      label: 'IVA (Débito Fiscal)',
      colspan: 1,
      columns: [
        { key: 'iva', label: 'IVA', format: 'money' }
      ]
    },
    {
      label: 'Totales',
      colspan: 1,
      columns: [
        { key: 'total', label: 'Total', format: 'money' }
      ]
    }
  ];


  formatCell(row: any, col: any): any {
    if (col.empty) return '';

    if (col.type === 'date') {
      return new Date(row[col.key]).toLocaleDateString('es-GT');
    }

    return row[col.key];
  }

  getNumberFormat(col: any): string {
    return col.format === 'money' ? '1.2-2' : '';
  }

}
